import { Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import aplicaciones from 'frontend/api/aplicaciones';
import Flex from 'frontend/commons/Flex';
import { getGeoData } from 'frontend/redux/actions/application-actions';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineGlobe } from 'react-icons/hi';
import { useDispatch, useSelector } from 'react-redux';
import AgencyCardContent from '../agencies/AgencyCardContent';
import ConsultaAgenciaModal from '../agencies/ConsultaAgenciaModal';
import './styles.css';

export default function MapAgencies() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { applicationId, geo } = useSelector((state) => state.applicationState);

  const [ agencies, setAgencies ] = useState([]);
  const [ selectedAgency, setSelectedAgency ] = useState();

  const getAgencies = useCallback(async () => {
    const { data: agencies} = await aplicaciones.getOffices(applicationId);
    setAgencies(agencies);
  }, [applicationId])

  const getAgencyLocationData = (agency) => {
    if (!geo) return;
    const { localities } = geo;

    const filteredLocality = localities.data.find((locality) => locality.id === agency.localidadId);
    return filteredLocality
  }

  const createGoogleMapUrl = (lat, lng) => {
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  }

const handleAgencyModalOpen = (agency) => {
  setSelectedAgency(agency)
}

  useEffect(() => {
    getAgencies();
    dispatch(getGeoData())
  }, [getAgencies])

  return (
    <Flex
      vertical
      className="map-agencies-container page-content-wrapper"
    >
      <Flex className="page__header">
        <h3 className="text-lg">
          <i
            className="fa fa-chevron-left back-button"
            onClick={() => history.back()}
          />
          {t('translations:offices')}
        </h3>
      </Flex>
      <Grid container spacing={2}>
        {agencies.map((agency) => {
          const location = getAgencyLocationData(agency);
          return (
          <Grid item xs={12} sm={6} md={4} key={agency.id}>
            <Card className='agencies__grid__card'>
              <CardContent>
                <AgencyCardContent agency={agency} location={location} />
              </CardContent>
              <CardActions>
                <Flex className='agencies__grid__card__row align-to-end'>
                    <a href={createGoogleMapUrl(agency.latitud, agency.longitud)} target="_blank" rel="noopener noreferrer">
                      <button className="agencies__grid__card__map_button">
                        <HiOutlineGlobe size={24}/>
                        <Typography>{t('translations:see_map')}</Typography>
                      </button>
                    </a>
                    <button className="agencies__grid__card__contact_button" onClick={() => handleAgencyModalOpen(agency)}>
                      <Typography>{t('translations:contact')}</Typography>
                    </button>
                </Flex>
              </CardActions>
            </Card>
          </Grid>
        )})}
      </Grid>
        <ConsultaAgenciaModal agency={selectedAgency} onClose={() => setSelectedAgency(null)} />
    </Flex>
  )
}
